import React, { useState, useEffect, useRef } from "react";
import RegularizacionTable from "./RegularizacionTable";
import HeaderData from "../HeaderData";
import { getUpdateDate } from "../utils/monthNames";
import SolicitudRegularizacion from "./SolicitudRegularizacion";
import { getConfiguracion, initializeSelectOptions, setInstalacionesDinamo, setPagadoresArcoprime } from "../utils/get";
import Select from "react-select";
import { SingleOption, customStylesPedidos, parseDate,parseBudat, getLocaleStringRoundedInt, parseDateAmerican, getExcelWithXlsx2 } from "../utils/utils.js";
import DatePicker from "react-datepicker";
import { getMaterialTitleCierre } from "../utils/materiales";
import download from "../../assets/img/DOWNLOAD.svg";
import { parentRedirect, showGreyBackground } from "../utils/windows";
import ExportExcelHidden from "../ExportExcelHidden";
import { RegularizacionMobile } from "./Responsive/RegularizacionMobile"

const Regularizacion = ({
  token,
  rutConcesionario,
  cabecera,
  instalaciones,
  isROImpersonate,
  edsPortal,
  callServiceHandler,
  pagador,
  params,
  setPagador
}) => {
  const [updateDate, setUpdateDate] = useState();
  const [selector, setSelector] = useState("LITROS");
  const [allEds, setAllEds] = useState([]);
  const [selectedEds, setSelectedEds] = useState();
  const [fecha, setFecha] = useState();
  const [filterText, setFilterText] = useState("");
  const [transacciones, setTransacciones] = useState();
  const [selectedTransaccion, setSelectedTransaccion] = useState();
  const [displaySolicitud, setDisplaySolicitud] = useState(false);
  const [configuracion, setConfiguracion] = useState();

  //Filtros
  const [filteredTransacciones, setFilteredTransacciones] = useState([]);
  const [allHoras, setAllHoras] = useState([]);
  const [horaFilter, setHoraFilter] = useState([]);

  const [allOrigen, setAllOrigen] = useState([]);
  const [origenFilter, setOrigenFilter] = useState([]);
  const [allFormaC, setAllFormaC] = useState([]);
  const [formaCFilter, setFormaCFilter] = useState([]);
  const [allFormaP, setAllFormaP] = useState([]);
  const [formaPFilter, setFormaPFilter] = useState([]);
  const [allDocumentos, setAllDocumentos] = useState([]);
  const [documentoFilter, setDocumentoFilter] = useState([]);
  const [allMateriales, setAllMateriales] = useState([]);
  const [materialFilter, setMaterialFilter] = useState([]);
  const [fechaParams, setFechaParams] = useState();
  const [fechaParamsUsed, setFechaParamsUsed] = useState(false);
  const [detalleVentas,setDetalleVentas] = useState();
  const [labelsVentas,setLabelsVentas] = useState()
  const [requestCounter, setRequestCounter] = useState(0)

  const [isArcoprime, setIsArcoprime] = useState(false);
  const [allPagadores, setAllPagadores] = useState([]);
  const [selectedPagador, setSelectedPagador] = useState();

  const [isEditando, setIsEditando] = useState(false);

  const isDesktopRef = useRef(window.innerWidth > process.env.REACT_APP_TABLET_BREAK_POINT)
  const isMobileTabletRef = useRef(window.innerWidth <= process.env.REACT_APP_TABLET_BREAK_POINT)
  
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT !== "dev") {
      if (token && rutConcesionario) {
        getUpdateDate(setUpdateDate);
        if(params){
          const paramsArr = params.split("&");
          let fecha = paramsArr[1].split("=")[1];
          setFechaParams(fecha);
        }
        if (rutConcesionario === "77215640-5") {
          setIsArcoprime(true);
        }
      }
    } else {
      if (token) {
        getUpdateDate(setUpdateDate);
        if(params){
          const paramsArr = params.split("&");
          let fecha = paramsArr[1].split("=")[1];
          setFechaParams(fecha);
        }
        if (rutConcesionario === "77215640-5" /* || true */) {
          setIsArcoprime(true);
        }
      }
    }
  }, [token, rutConcesionario]);

  function filterBySearchText(newFilteredTransacciones){
    if(filterText !== ''){
      let filterTextLower = filterText.toLowerCase()
      filterTextLower = filterTextLower.replaceAll(".", "");
      filterTextLower = filterTextLower.replaceAll(",", "");

      newFilteredTransacciones = newFilteredTransacciones.filter((tr) => {
        return (
          (tr.ID_TRANSACCION && tr.ID_TRANSACCION.toString().includes(filterTextLower)) ||
          (tr.HORA && tr.HORA.toString().includes(filterTextLower)) ||
          (tr.ORIGEN_VENTA && tr.ORIGEN_VENTA.toLowerCase().includes(filterTextLower)) ||
          (tr.FORMA_COMERCIALIZACION && tr.FORMA_COMERCIALIZACION.toLowerCase().includes(filterTextLower)) ||
          (tr.FORMA_PAGO && tr.FORMA_PAGO.toLowerCase().includes(filterTextLower)) ||
          (tr.DOCUMENTO_VENTA && tr.DOCUMENTO_VENTA.toLowerCase().includes(filterTextLower)) ||
          (tr.MATERIAL && tr.MATERIAL.toLowerCase().includes(filterTextLower)) ||
          (tr.PRECIO && tr.PRECIO.toString().replaceAll(".", "").replaceAll(",", "").includes(filterTextLower)) ||
          (selector === "LITROS" && 
            ( 
              tr.LITROS.controlador && 
              getLocaleStringRoundedInt(tr.LITROS.controlador.toString()).replaceAll(".", "").replaceAll(",", "").includes(filterTextLower)
              || 
              tr.LITROS.documentados && 
              getLocaleStringRoundedInt(tr.LITROS.documentados.toString()).replaceAll(".", "").replaceAll(",", "").includes(filterTextLower)
              || 
              tr.LITROS.confirmados && 
              getLocaleStringRoundedInt(tr.LITROS.confirmados.toString()).replaceAll(".", "").replaceAll(",", "").includes(filterTextLower)
            )
          ) ||
          (selector === "PESOS" && 
            ( 
              tr.PESOS.controlador && 
              getLocaleStringRoundedInt(tr.PESOS.controlador.toString()).replaceAll(".", "").replaceAll(",", "").includes(filterTextLower)
              || 
              tr.PESOS.documentados && 
              getLocaleStringRoundedInt(tr.PESOS.documentados.toString()).replaceAll(".", "").replaceAll(",", "").includes(filterTextLower)
              || 
              tr.PESOS.confirmados && 
              getLocaleStringRoundedInt(tr.PESOS.confirmados.toString()).replaceAll(".", "").replaceAll(",", "").includes(filterTextLower)
            )
          )
        )
      })
    }
    setFilteredTransacciones(newFilteredTransacciones)
  }

  useEffect(() => {
    if (instalaciones !== "") {
      if(!isArcoprime){
        setInstalacionesDinamo(instalaciones,setAllEds)
      }
    }
  }, [instalaciones]);

  useEffect(() => {
    if (selectedEds){
      getConfiguracion(callServiceHandler, selectedEds.value, setConfiguracion);
      if(fechaParams && !fechaParamsUsed){
        const parts =fechaParams.split('-');
        const theDate = new Date(parts[0], parts[1] - 1, parts[2]); 
        setFecha(theDate)
        setFechaParamsUsed(true);
      }
    }
  }, [selectedEds]);

  useEffect(() => {
    if (allEds.length === 1) {
      changeEds(allEds[0]);
    }else{
      if(params){
        const paramsArr = params.split("&");
        const edsParam = paramsArr[0].split("=")[1];
        changeEds(allEds.filter(eds=>eds.value===edsParam)[0])
      }
    }
  }, [allEds]);

  useEffect(async () => {
    if(selectedPagador){
      const url = process.env.REACT_APP_PEDIDOS_API +
      "/pedidos/obtener-instalaciones-cliente?id_pagador=" + selectedPagador.value;

      let result = await callServiceHandler(url, "GET")
      if(result !== "error"){
        setInstalacionesDinamo(result.data, setAllEds);
      }
      setPagador(selectedPagador.value)

    }
  }, [selectedPagador]);

  useEffect(() => {
    if(edsPortal){
      setPagadoresArcoprime(edsPortal.data.user_eds,setAllPagadores);
    }
  }, [edsPortal]);

  useEffect(() => {
    if(selectedTransaccion){
      console.log("Cambio selected Transaccion:: ", selectedTransaccion?.ID_TRANSACCION)
    }
  }, [selectedTransaccion])

  useEffect(() => {
    if (allPagadores.length === 1) {
      changePagador(allPagadores[0]);
    }
  }, [allPagadores]);

  function changePagador(e) {
    setSelectedPagador(e);
  }

  useEffect(() => {
    if (fecha && selectedEds) {
      fetchTransacciones();
    }
  }, [fecha,selectedEds]);

  async function changeEds(e) {
    if (e !== selectedEds) {
      setSelectedEds(e);
    }
  }

  function changeSelectedTransaccion(t) {
    setSelectedTransaccion(t);
  }

  function hasRegularizacion(trx) {
    const idRegularizacion = trx?.ID_REGULARIZACION;
    const infoGuardada = trx?.INFO_GUARDADA;
    const hasId = idRegularizacion !== undefined && idRegularizacion !== null && idRegularizacion !== "";
    const hasInfo = infoGuardada && (
      typeof infoGuardada !== "object" || Object.keys(infoGuardada).length > 0
    );

    return Boolean(hasId || hasInfo);
  }

  function regularizarVenta() {
    setIsEditando(false);
    setDisplaySolicitud(true);
  }

  function changeSelector() {
    const tselector = document.getElementById("table-selector");
    if (tselector.checked) {
      tselector.checked = false;
      setSelector("LITROS");
    } else {
      tselector.checked = true;
      setSelector("PESOS");
    }
  }

  async function fetchTransacciones(options = {}) {
    const keepSelectedTransaccion = options?.keepSelectedTransaccion === true;
    let idPagador = isArcoprime?selectedPagador.value:pagador;

    const url =
      process.env.REACT_APP_FLUCTUACIONES_API +
      "/fluctuaciones/listado-transacciones-regularizar-portal?ID_EDS=" +
      selectedEds.value +
      "&FECHA=" +
      parseDate(fecha)+"&ID_PAGADOR="+idPagador+"&RUT=" + rutConcesionario;

    let response = await callServiceHandler(url, "GET");
    if (response !== "error") {
      const cleanedTransacciones = cleanTransaccionesData(response.data.detalles);
      if(!keepSelectedTransaccion){
        setSelectedTransaccion();
      } else if (selectedTransaccion?.ID_TRANSACCION) {
        const refreshedSelectedTransaccion = cleanedTransacciones.find(
          (trx) => trx.ID_TRANSACCION === selectedTransaccion.ID_TRANSACCION
        );
        if(refreshedSelectedTransaccion){
          setSelectedTransaccion(refreshedSelectedTransaccion);
        }
      }
    }
  }

  async function getDetalleVentas(){
    console.log("FECHA",fecha)
    const url =
    process.env.REACT_APP_FLUCTUACIONES_API +
    "/fluctuaciones/cierre-diario-listado-transacciones?ID_EDS=" +
    selectedEds.value +
    "&FECHA="+parseDateAmerican(fecha)+"&ID_PAGADOR="+pagador+"&TIPO=3"+"&RUT="+rutConcesionario;
    
    let docName = `Detalle de Ventas - ${parseInt(selectedEds.value)} - ${fecha}.xlsx`

    let response = await callServiceHandler(url, "GET");

    
    
    console.log(response.data.hojas)
    
    getExcelWithXlsx2(response.data.hojas, docName)
    // if (response !== "error"){
    //   setLabelsVentas(response.data.labels);
    //   setDetalleVentas(response.data.transacciones);
    //   setRequestCounter((old)=>old+1)
    // }
  }

  function cleanTransaccionesData(data) {
    const newTransacciones = [];
    const horasOptions = initializeSelectOptions();
    const origenOptions = initializeSelectOptions();
    const formaCOptions = initializeSelectOptions();
    const formaPOptions = initializeSelectOptions();
    const documentosOptions = initializeSelectOptions();
    const materialesOptions = initializeSelectOptions();

    data.map((trx) => {
      if (
        trx.hora !== "TOTAL" &&
        horasOptions.filter((e) => e.value === trx.hora).length == 0
      ) {
        const newHora = {
          label: trx.hora,
          value: trx.hora,
        };
        horasOptions.push(newHora);
      }

      if (
        trx.origen_venta !== "TOTAL" &&
        origenOptions.filter((e) => e.value === trx.origen_venta).length == 0
      ) {
        const newOrigen = {
          label: trx.origen_venta,
          value: trx.origen_venta,
        };
        origenOptions.push(newOrigen);
      }

      if (
        trx.forma_comercializacion !== "TOTAL" &&
        formaCOptions.filter((e) => e.value === trx.forma_comercializacion).length == 0
      ) {
        const newFormaC = {
          label: trx.forma_comercializacion,
          value: trx.forma_comercializacion,
        };
        formaCOptions.push(newFormaC);
      }

      if (
        trx.forma_pago !== "TOTAL" &&
        formaPOptions.filter((e) => e.value === trx.forma_pago).length == 0
      ) {
        const newFormaP = {
          label: trx.forma_pago,
          value: trx.forma_pago,
        };
        formaPOptions.push(newFormaP);
      }

      if (
        trx.documento_venta !== "TOTAL" &&
        documentosOptions.filter((e) => e.value === trx.documento_venta).length == 0
      ) {
        const newDocumento = {
          label: trx.documento_venta,
          value: trx.documento_venta,
        };
        documentosOptions.push(newDocumento);
      }

      if (
        trx.material_nombre !== "TOTAL" &&
        materialesOptions.filter((e) => e.value === trx.material_nombre).length == 0
      ) {
        const newMaterial = {
          label: trx.material_nombre,
          value: trx.material_nombre,
        };
        materialesOptions.push(newMaterial);
      }

      const newTransaccion = {
        ID_TRANSACCION: trx.id_transaccion,
        HORA: trx.hora,
        ORIGEN_VENTA: trx.origen_venta,
        FORMA_COMERCIALIZACION: trx.forma_comercializacion,
        FORMA_PAGO: trx.forma_pago,
        DOCUMENTO_VENTA: trx.documento_venta,
        MATERIAL: trx.material_nombre,
        MATERIAL_CODE:trx.material_sap_id,
        MATERIAL_SAP_LIST:trx.material_sap_list,
        PRECIO: trx.precio,
        ALERTA: trx.alerta,
        DISABLE_REG:trx.disable_reg,
        LITROS: trx.litros,
        PESOS: trx.pesos,
        TANQUE:trx.tanque,
        TIPO_VENTA:trx.tipo_venta,
        INFO:trx.info,
        ID_REGULARIZACION:trx.id_regularizacion,
        INFO_GUARDADA:trx.informacion_guardada
      };
      newTransacciones.push(newTransaccion);
    });

    setTransacciones(newTransacciones);
    setAllHoras(horasOptions);
    setAllOrigen(origenOptions);
    setAllFormaC(formaCOptions);
    setAllFormaP(formaPOptions);
    setAllDocumentos(documentosOptions);
    setAllMateriales(materialesOptions);

    return newTransacciones;
  }

  function goBackStep2(){
    const paramsArr = params.split("&");
    const edsParam = paramsArr[0].split("=")[1];
    const fechaParam = paramsArr[1].split("=")[1];
    const url = process.env.REACT_APP_CIERRE_DIARIO_PATH+"?eds="+edsParam+"&fecha="+fechaParam;
    parentRedirect(url);
  }

  function editarRegularizacion(trx){
    if (!hasRegularizacion(trx)) return;
    setDisplaySolicitud(true)
    setIsEditando(true)
    if(isMobileTabletRef.current){
      showGreyBackground()
    }
  }

  return (
    <div className="regularizacion new-responsive-page">
      <div className="title-container">
        <div className="title">
          <div className="view-title">Cierre de Operaciones</div>
          <div className="view-title-separator">|</div>
          <div className="view-subtitle">Regularización de ventas</div>
        </div>
        {params && 
          <div className="volver-arrow cursor-pointer show-only-desktop" onClick={()=>goBackStep2()} >
            <img></img>
            <p className="volver-text">Volver ({parseBudat(fechaParams)})</p>
          </div>
        }
        
      </div>
      <hr className="title-separator-line" />
      <div className="show-only-desktop">
        <HeaderData
          rutConcesionario={rutConcesionario}
          token={token}
          actualizacion={updateDate}
          cabecera={cabecera}
          actualizable={true}
          updateFunction={fetchTransacciones}
          callServiceHandler={callServiceHandler}
        />
        <hr />
      </div>

      {!displaySolicitud && (
        <>
          <div className={`regularizacion-options`}>
            <div className="filters-container">
              {isArcoprime &&
                <div className="filter">
                  <div className="filter-title">
                    ID DE PAGADOR<span className="red-asterisk">*</span>
                  </div>
                  <div className="filter-input">
                    <Select
                      className="eds-select"
                      value={selectedPagador}
                      onChange={(e) => changePagador(e)}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      options={allPagadores}
                      components={{
                        SingleOption,
                        IndicatorSeparator: () => null,
                      }}
                      isClearable={false}
                      autosize={false}
                      placeholder="Seleccionar"
                      isSearchable={isDesktopRef.current? true: false}
                      styles={customStylesPedidos}
                    />
                  </div>
                </div>
              }
              <div className={`filter${isArcoprime?" mleft":""} tablet-float-left`}>
                <div className="filter-title">
                  ESTACIÓN DE SERVICIO<span className="red-asterisk">*</span>
                </div>
                <div className="filter-input">
                  <Select
                    className="eds-select"
                    value={selectedEds}
                    onChange={(e) => changeEds(e)}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    options={allEds}
                    components={{
                      SingleOption,
                      IndicatorSeparator: () => null,
                    }}
                    isClearable={false}
                    autosize={false}
                    placeholder="Seleccionar"
                    styles={customStylesPedidos}
                    isSearchable={isDesktopRef.current? true: false}
                  />
                </div>
              </div>
              <div className="filter mleft tablet-float-right">
                <div className="filter-title required-field">FECHA</div>
                <div className="filter-input">
                  <DatePicker
                    locale="es"
                    selected={fecha}
                    onChange={(e) => setFecha(e)}
                    shouldCloseOnSelect={true}
                    dateFormat="dd/MM/yyyy"
                    maxDate={new Date()}
                    placeholderText="Seleccionar"
                    /* disabled={step !== 1} */
                  />
                </div>
              </div>
              <div className="filter show-only-desktop">
                <div className="filter-input">
                  <input
                    type="search"
                    className="search"
                    value={filterText}
                    placeholder="Buscar..."
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </div>
              </div>
            </div>
            {params && 
              <div className="responsive-actions show-only-mobile">
                <button className="main-button hallow" onClick={goBackStep2}>
                  Volver ({parseBudat(fechaParams)})
                </button>
              </div>
            }
            <div className="actions show-only-desktop">
              <button className="main-button hallow iconbutton" onClick={()=>selectedEds&&fecha?getDetalleVentas():""}><img src={download} alt="" />Detalle ventas</button>
              
              <button
                className={`main-button ${!selectedTransaccion && "disabled"}`}
                onClick={regularizarVenta}
                disabled={selectedTransaccion?hasRegularizacion(selectedTransaccion):true}
              >
                Regularizar venta
              </button>
              <button
                className={`main-button ${!selectedTransaccion && "disabled"}`}
                onClick={() => editarRegularizacion(selectedTransaccion)}
                disabled={selectedTransaccion?!hasRegularizacion(selectedTransaccion):true}
              >
                Editar Regularización
              </button>
            </div>
          </div>
          <RegularizacionMobile 
            transacciones={transacciones}
            selectedTransaccion={selectedTransaccion}
            changeSelectedTransaccion={changeSelectedTransaccion}
            regularizarVenta={regularizarVenta}
            editarRegularizacion={editarRegularizacion}
            hasRegularizacion={hasRegularizacion}
            displaySolicitud={displaySolicitud}
            params={params}
            fechaParams={fechaParams}
            goBackStep2={goBackStep2}
          />

          <RegularizacionTable
            changeSelector={changeSelector}
            transacciones={transacciones}
            selector={selector}
            selectedTransaccion={selectedTransaccion}
            changeSelectedTransaccion={changeSelectedTransaccion}
            filteredTransacciones={filteredTransacciones}
            setFilteredTransacciones={setFilteredTransacciones}
            allHoras={allHoras}
            horaFilter={horaFilter}
            setHoraFilter={setHoraFilter}
            allOrigen={allOrigen}
            origenFilter={origenFilter}
            setOrigenFilter={setOrigenFilter}
            allFormaC={allFormaC}
            formaCFilter={formaCFilter}
            setFormaCFilter={setFormaCFilter}
            allFormaP={allFormaP}
            formaPFilter={formaPFilter}
            setFormaPFilter={setFormaPFilter}
            allDocumentos={allDocumentos}
            documentoFilter={documentoFilter}
            setDocumentoFilter={setDocumentoFilter}
            allMateriales={allMateriales}
            materialFilter={materialFilter}
            setMaterialFilter={setMaterialFilter}
            filterText={filterText}
            filterBySearchText={filterBySearchText}
          />
        </>
      )}

      {displaySolicitud && (
        <SolicitudRegularizacion
          selectedTransaccion={selectedTransaccion}
          setDisplaySolicitud={setDisplaySolicitud}
          selectedEds={selectedEds}
          fecha={fecha}
          configuracion={configuracion}
          callServiceHandler={callServiceHandler}
          fetchTransacciones={fetchTransacciones}
          setSelectedTransaccion={setSelectedTransaccion}
          pagador={pagador}
          isEditando={isEditando}
          setIsEditando={setIsEditando}
        />
      )}
    </div>
  );
};

export default Regularizacion;
